import PropTypes from 'prop-types';
import { Box, IconButton } from '@mui/material';

import { componentsSize, roundedComponentVariants } from 'constants/components';

const styles = {
  button: ({ palette, breakpoints }, variant, transparent) => ({
    '&.MuiIconButton-root': {
      padding: 0.5,
      ...(variant === roundedComponentVariants.squared && {
        borderRadius: '10px',
      }),
    },
    '&.MuiIconButton-sizeSmall': {
      width: 24,
      height: 24,
    },
    '&.MuiIconButton-sizeMedium': {
      width: 28,
      height: 28,
      [breakpoints.up('md')]: {
        width: 34,
        height: 34,
      },
    },
    '&.MuiIconButton-sizeLarge': {
      width: 40,
      height: 40,
      padding: 1,
      [breakpoints.up('md')]: {
        width: 56,
        height: 56,
        padding: 1.5,
      },
    },
    '&.MuiIconButton-colorPrimary': {
      backgroundColor: palette.primary.main,

      '&:hover': {
        backgroundColor: palette.primary.main,
      },

      ...(transparent && {
        backgroundColor: 'transparent',
        border: `2px solid ${palette.primary.main}`,
        svg: {
          color: palette.primary.main,
        },
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }),
    },
    '&.MuiIconButton-colorSecondary': {
      backgroundColor: palette.secondary.main,

      '&:hover': {
        backgroundColor: palette.secondary.main,
      },
    },
    '&.MuiIconButton-colorInfo': {
      backgroundColor: palette.info.main,

      '&:hover': {
        backgroundColor: palette.info.main,
      },
    },
    '&.MuiIconButton-colorSuccess': {
      backgroundColor: palette.success.main,

      '&:hover': {
        backgroundColor: palette.success.main,
      },
    },
    '&.MuiIconButton-colorError': {
      backgroundColor: palette.error.main,

      '&:hover': {
        backgroundColor: palette.error.main,
      },
    },
    '&.MuiIconButton-colorWarning': {
      backgroundColor: palette.warning.main,

      '&:hover': {
        backgroundColor: palette.warning.main,
      },
    },
    '&.Mui-disabled': {
      opacity: 0.45,
    },
  }),
  icon: ({ palette }) => ({
    width: '100%',
    height: '100%',
    maxWidth: 35,
    maxHeight: 35,
    color: palette.common.white,
  }),
};

const ColorButton = ({
  icon,
  variant = roundedComponentVariants.squared,
  transparent = false,
  customStyles = {},
  size = componentsSize.large,
  ...iconButtonProps
}) => (
  <IconButton
    size={size}
    sx={[(theme) => styles.button(theme, variant, transparent), customStyles]}
    {...iconButtonProps}
  >
    <Box component={icon} sx={styles.icon} />
  </IconButton>
);

ColorButton.propTypes = {
  icon: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(Object.values(roundedComponentVariants)),
  size: PropTypes.oneOf(Object.values(componentsSize)),
  transparent: PropTypes.bool,
  customStyles: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
};
export default ColorButton;
